export const ru = {
    add: 'Добавить'
};
